import './App.css';
import {Grid} from "@mui/system";
import '@fontsource/quicksand/300.css';
import '@fontsource/quicksand/400.css';
import '@fontsource/quicksand/500.css';
import '@fontsource/quicksand/600.css';
import '@fontsource/quicksand/700.css';
import '@fontsource/bebas-neue/400.css';
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect, useState} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {collection, orderBy, query} from "firebase/firestore";
import {fire} from "./fire";
import {obtenerCol} from "./Servicios/BD/obtenerCol";
import {actualizarDoc} from "./Servicios/BD/actualizarDoc";
import PaginaConstruccion from "./PaginaConstruccion/PaginaConstruccion";
import Pagina from "./Pagina/Pagina";

export const contexApp = createContext()


function App() {
    const [cargando, setCargando] = useState(false)
    const {data: categorias, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({
        clave: 'categorias',
    })

    const valoresProvider = {
        categorias
    }

    const {Provider} = contexApp;


    const colocarPrioridades = async () => {

        setCargando(true)
        let dox = await obtenerCol('productos')
        let productos = dox.data

        for (let producto of productos) {
            let catego = categorias.filter((cat) => cat.nombre === producto.categoria)[0]
            await actualizarDoc('productos', producto.id, {prioridad: catego.prioridad})
        }

        setCargando(false)

    }


    useEffect(() => {

        //se verifica si esta o no actualizado

        obtenerFechaAct('categorias').then((dox) => {
            let w = []
            let q = query(collection(fire, 'categorias'), orderBy('prioridad', 'asc'))
            actCategorias({fecha: dox, wheres: w, query: q}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <h1 style={{display: 'none'}}>Formación Técnica Laboral en Ipiales y Nariño | Cessa Universidad</h1>
            <h2 style={{display: 'none'}}>Un modelo innovador basado en Escuelas de Aprendizaje</h2>
            <h2 style={{display: 'none'}}>Técnicos Laborales por Competencias con Alta Empleabilidad</h2>
            <h2 style={{display: 'none'}}>Programas en Salud, Administración, Tecnología y Estética</h2>
            <h2 style={{display: 'none'}}>Inicia tu camino a la Profesionalización y Posgrados</h2>

            <Provider value={valoresProvider}>
                <PaginaConstruccion/>
            </Provider>

            {/*<Button
                loading={cargando}
                onClick={() => colocarPrioridades()}
            >
                Colocar prioridad
            </Button>*/}

        </Grid>
    );
}

export default App;
